const SEO_CONSTANTS = {
  Home: "/",
  Shop: "/shop",
  ContactUs: "/contact-us",
  Cart: "/cart",
  Checkout: "/checkout",
  Wishlist: "/wishlist",
  Login: "/login",
  Register: "/register",
  ForgotPassword: "/forgot-password",
  MyAccount: "/my-account",
  Orders: "/orders",
  OrderTracking: "/order-tracking",
  Blogs: "/blogs",
  Categories: "/categories",
  Brands: "/brands",
  Search: "/search",
  ThankYou: "/thank-you",
  PaymentFailed: "/payment-failed",
};

export default SEO_CONSTANTS;
